<template>
  <div ref="container" class="gmf-like-animation-container">
    <slot></slot>
  </div>
</template>

<script>
import { createApp } from 'vue';
import Icon from '@/components/Icon';
import createEl from '@/utils/createEl';

export default {
  name: 'LikeAnimation',
  props: {
    icon: {
      type: String,
      default: 'like',
    },
    color: {
      type: String,
      default: 'var(--gmf-col-like)',
    },
  },
  methods: {
    trigger() {
      // Create 4 hearts going in different directions
      const directions = ['up', 'down', 'left', 'right'];
      directions.forEach(direction => {
        const heartParticle = createEl('div', ['gmf-heart-particle', `gmf-heart-particle-${direction}`]);
        heartParticle.style.setProperty('--gmf-icon-color', this.color, 'important');
        createApp(Icon, { icon: this.icon }).mount(heartParticle);
        // Also set the color on the icon element itself after mounting
        const iconEl = heartParticle.querySelector('.gmf-icon');
        if (iconEl) {
          iconEl.style.setProperty('--gmf-icon-color', this.color, 'important');
        }
        this.$refs.container.appendChild(heartParticle);
        window.setTimeout(() => {
          //heartParticle.remove();
        }, 800);
      });
      
      // Add bounce animation to the container
      this.$refs.container.classList.add('gmf-bounce');
      window.setTimeout(() => {
        this.$refs.container.classList.remove('gmf-bounce');
      }, 400);
    }
  }
};
</script>

<style>
.gmf-like-animation-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gmf-like-animation-container.gmf-bounce {
  animation: gmf-heart-bounce 0.4s ease-in-out;
}

.gmf-heart-particle {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gmf-heart-particle .gmf-icon {
  width: 12px;
  height: 12px;
}

.gmf-heart-particle-up {
  animation: gmf-heart-particle-up 0.8s ease-out forwards;
}

.gmf-heart-particle-down {
  animation: gmf-heart-particle-down 0.8s ease-out forwards;
}

.gmf-heart-particle-left {
  animation: gmf-heart-particle-left 0.8s ease-out forwards;
}

.gmf-heart-particle-right {
  animation: gmf-heart-particle-right 0.8s ease-out forwards;
}

@keyframes gmf-heart-bounce {
  0%, 100% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.3);
  }
  50% {
    transform: scale(0.9);
  }
  75% {
    transform: scale(1.1);
  }
}

@keyframes gmf-heart-particle-up {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -150%) scale(0.3);
    opacity: 0;
  }
}

@keyframes gmf-heart-particle-down {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, 50%) scale(0.3);
    opacity: 0;
  }
}

@keyframes gmf-heart-particle-left {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-150%, -50%) scale(0.3);
    opacity: 0;
  }
}

@keyframes gmf-heart-particle-right {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(50%, -50%) scale(0.3);
    opacity: 0;
  }
}
</style>

